import { getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { sponsoredProductCampaignTypes } from './ad-type-config';

// These urls is not find in sitemap
// Keep the orignal behavior to navigate to old campaign page
const toolsPathMap = urlIds => ({
  ImportFile: `/Campaign/ImportCampaign/FileImport?${urlIds}`,
  GoogleImport: `/Campaign/ImportCampaign/GoogleImport?${urlIds}`,
  FreeCoach: 'http://go.microsoft.com/fwlink?LinkId=398320',
});

export function navigateToRoute(scope, siteMap, id) {
  const pathname = getRoutePathById(siteMap, id);

  scope.history.push({
    pathname,
    search: scope.history.location.search,
  });
}

export function navigateSelectedObjective({
  isDisplayAds,
  isVideo,
  isMediaPackage,
  isAudience,
  isShopping,
  isSmartShopping,
  isPerfMax,
  sponsoredBrandAdType,
  scope,
  siteMap,
  isNewAudience,
  isNewSearch,
  permissions,
}) {
  let id = null;
  if (isVideo) {
    if (permissions.dynamic.XandrVideoCampaigns) {
      id = 'campaign-create-xandr-video';
    } else {
      id = 'campaign-create-videoaudience';
    }
  } else if (isDisplayAds) {
    id = 'campaign-create-xandr-display-ads';
  } else if (isMediaPackage) {
    id = 'campaign-create-xandr-mediadeal';
  } else if (isPerfMax) {
    id = 'campaign-create-pmax';
  } else if (isAudience) {
    if (isShopping) {
      id = 'campaign-create-shoppingaudience';
    } else {
      id = `campaign-create-${isNewAudience ? 'audience-simplified' : 'audience'}`;
    }
  } else if (sponsoredBrandAdType === sponsoredProductCampaignTypes.spa) {
    id = 'campaign-create-shopping-spa';
  } else if (sponsoredBrandAdType === sponsoredProductCampaignTypes.spb) {
    id = 'campaign-create-shopping-spb';
  } else if (!isSmartShopping) {
    const searchId = isNewSearch ? 'search-v2' : 'search';
    id = `campaign-create-${isShopping ? 'shopping' : searchId}`;
  } else {
    id = 'campaign-create-smart-shopping';
  }

  navigateToRoute(scope, siteMap, id);
}

export function navigateSelectedTools({
  scope, siteMap, permissions, id: itemId, siteMapId, siteMapAvailable,
}) {
  if (siteMapAvailable && siteMapAvailable(permissions)) {
    navigateToRoute(scope, siteMap, siteMapId);
    return;
  }

  const {
    values: {
      cid,
      uid,
      aid,
    },
  } = scope;
  const urlIds = `cid=${cid}&uid=${uid}&aid=${aid}`;
  const itemTarget = itemId === 'FreeCoach' ? '_blank' : '_self';

  window.open(toolsPathMap(urlIds)[itemId], itemTarget);
}
